import { COUNTRY_CODE_PATTERN } from '~/utils/localePattern';

/** Vue Router matches the path case-insensitive and ignores a trailing slash. */
const CHECKOUT_PATH_REGEX = new RegExp(`^/${COUNTRY_CODE_PATTERN}-[a-z]{2}/shop/checkout(?:/|$)`, 'i');

/**
 * Returns `true` for `/<locale>/shop/checkout` and for each page below it, for example
 * `/de-de/shop/checkout/success/123`. The function ignores the query and the hash.
 */
export function isCheckoutPath(path: string): boolean {
    return CHECKOUT_PATH_REGEX.test(path.split(/[?#]/, 1)[0] ?? '');
}
